module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [(_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.hintMsg,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-refresh-control', {
    attrs: {
      "refreshing": _vm.refreshing,
      "trigger": _vm.trigger
    },
    on: {
      "refresh": _vm.refresh
    }
  }), _vm._v(" "), _c('mu-appbar', {
    staticStyle: {
      "height": "1rem"
    }
  }, [_c('mu-icon', {
    staticStyle: {
      "margin-top": "0.05rem"
    },
    attrs: {
      "slot": "left",
      "value": "keyboard_arrow_left",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    },
    slot: "left"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "0.38rem"
    }
  }, [_vm._v("新闻列表")]), _vm._v(" "), _c('mu-icon', {
    staticStyle: {
      "margin-bottom": "-0.05rem"
    },
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_left",
      "color": "#27ba69"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#fff",
      "min-height": "12.4rem"
    }
  }, [_c('mu-tabs', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "1",
      "title": "全部"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "2",
      "title": "集团"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "3",
      "title": "开业"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "4",
      "title": "媒体"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "5",
      "title": "社会"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "6",
      "title": "游记"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.3rem"
    }
  }), _vm._v(" "), _vm._l((["1", "2", "3", "4", "5", "6"]), function(ListName, index) {
    return _c('div', {
      staticStyle: {}
    }, _vm._l((_vm.BreakfastList[_vm.activeTab]), function(item, index) {
      return (ListName == _vm.activeTab) ? _c('div', {
        on: {
          "click": function($event) {
            return _vm.LookDetail(item.ID)
          }
        }
      }, [_c('div', {
        staticStyle: {
          "width": "6.9rem",
          "margin": "0  0.3rem",
          "overflow": "hidden",
          "border-bottom": "1px solid #dddddd",
          "height": "1.6rem",
          "background-color": "#fff"
        }
      }, [_c('img', {
        staticStyle: {
          "width": "1.84rem",
          "height": "1.38rem",
          "float": "left"
        },
        attrs: {
          "src": item.Pic
        }
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "width": "0.3rem",
          "height": "1.3rem",
          "float": "left"
        }
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "width": "4.5rem",
          "float": "left",
          "margin-top": "-0.06rem"
        }
      }, [_c('div', {
        staticStyle: {
          "display": "-webkit-box",
          "-webkit-line-clamp": "2",
          "-webkit-box-orient": "vertical",
          "overflow": "hidden",
          "font-size": "0.3rem",
          "color": "#333",
          "height": "0.9rem"
        }
      }, [_vm._v("\n              " + _vm._s(item.Title) + "\n            ")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "height": "0.2rem"
        }
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "font-size": "0.22rem"
        }
      }, [_vm._v("\n              " + _vm._s(item.Create_Time) + " |\n              "), _c('span', [_vm._v("\n                " + _vm._s(item.ClassName) + "\n              ")])])])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "height": "0.2rem"
        }
      })]) : _vm._e()
    }), 0)
  }), _vm._v(" "), _c('loadListTail', {
    attrs: {
      "mainTitle": "此处无新闻",
      "mainIcon": "noInvoice",
      "noMore": _vm.loadState[this.activeTab].stop,
      "isLoading": _vm.loadState[this.activeTab].loading,
      "overZero": _vm.BreakfastList[_vm.activeTab].length > 0
    }
  }), _vm._v(" "), (_vm.loadState[this.activeTab].loading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "0.2rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.2rem"
    },
    attrs: {
      "src": require("../../../static/LoadingBest.gif")
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.1rem"
    }
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d633525!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/NewsCenter.vue
// module id = 1497
// module chunks = 18